var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLeft,
              expression: "showLeft",
            },
          ],
          staticClass: "left_tree",
        },
        [
          _c(
            "a-spin",
            {
              staticStyle: { height: "100%" },
              attrs: { spinning: _vm.treeSpin },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "a-radio-group",
                    {
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [
                      _c("a-radio-button", { attrs: { value: "dept" } }, [
                        _vm._v(" 部门 "),
                      ]),
                      _c("a-radio-button", { attrs: { value: "customer" } }, [
                        _vm._v(" 员工 "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      on: { click: _vm.closeAll },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
              _vm.type === "dept"
                ? _c(
                    "div",
                    { staticClass: "tree-box" },
                    [
                      _c(
                        "a-tree",
                        {
                          attrs: {
                            "show-icon": true,
                            checkable: "",
                            "expanded-keys": _vm.expandedKeys,
                            "auto-expand-parent": _vm.autoExpandParent,
                            "selected-keys": _vm.selectedKeys,
                            "tree-data": _vm.treeData,
                            selectable: false,
                            replaceFields: {
                              children: "children",
                              title: "deptName",
                              key: "deptId",
                            },
                          },
                          on: { expand: _vm.onExpand, check: _vm.onSelect },
                          model: {
                            value: _vm.checkedKeys,
                            callback: function ($$v) {
                              _vm.checkedKeys = $$v
                            },
                            expression: "checkedKeys",
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { color: "#2fcfeb" },
                            attrs: { slot: "dealer", type: "team" },
                            slot: "dealer",
                          }),
                          _c("a-icon", {
                            staticStyle: { color: "#52c41a" },
                            attrs: { slot: "region", type: "cluster" },
                            slot: "region",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === "customer"
                ? _c(
                    "div",
                    { staticClass: "tree-box" },
                    [
                      _c("Tree", {
                        attrs: {
                          list: _vm.treeData,
                          selectedUser: _vm.selectedUser,
                          userName: "",
                          detph: 0,
                        },
                        on: { change: _vm.checkedUser },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right_table", class: { showLeft: !_vm.showLeft } },
        [
          _vm.showLeft
            ? _c("a-icon", {
                staticClass: "close",
                attrs: { type: "left-circle" },
                on: {
                  click: function ($event) {
                    _vm.showLeft = false
                  },
                },
              })
            : _c("a-icon", {
                staticClass: "close",
                attrs: { type: "right-circle" },
                on: {
                  click: function ($event) {
                    _vm.showLeft = true
                  },
                },
              }),
          _c("x-grid", {
            ref: "grid",
            attrs: {
              id: "formList",
              rowId: _vm.rowId,
              "pager-config": _vm.pagerConfig,
              "form-config": _vm.formConfig,
              url: _vm.url,
              columns: _vm.columns,
              "checkbox-config": _vm.checkboxConfig,
              "toolbar-config": _vm.toolbarConfig,
              "print-config": _vm.printConfig,
              "export-config": _vm.exportConfig,
              "other-params": {
                startDate: _vm.startDate,
                endDate: _vm.endDate,
                isFollowCust: _vm.isFollowCust,
                regionId: _vm.regionId,
                dealerId: _vm.dealerId,
                followUserId: _vm.followUserId,
                deptId: _vm.deptId,
              },
              cellClick: _vm.chooseRow,
              cellDbClick: _vm.updateRow,
            },
            on: {
              "toolbar-addData": _vm.addRow,
              "toolbar-delData": _vm.delRow,
            },
            scopedSlots: _vm._u([
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        row.isRepeat === 1
                          ? _c("a-icon", {
                              staticStyle: {
                                color: "red",
                                "font-size": "16px",
                                "margin-right": "6px",
                              },
                              attrs: { type: "exclamation-circle" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.repeat(row)
                                },
                              },
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(row.custNo))]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "popModal",
        { attrs: { title: "共享人", "pop-config": _vm.popConfig.sharePeople } },
        [
          _c("sharePeople", {
            ref: "sharePeople",
            attrs: {
              type: "sharePeople",
              mainRowId: _vm.popConfig.sharePeople.id,
              row: _vm.popConfig.sharePeople.row,
            },
            on: { closePop: _vm.closePopAndRefresh },
          }),
        ],
        1
      ),
      _c(
        "popModal",
        {
          attrs: {
            title: "跟进人",
            "pop-config": _vm.popConfig.followUpPeople,
          },
        },
        [
          _c("followUpPeople", {
            ref: "followUpPeople",
            attrs: {
              type: "followUpPeople",
              mainRowId: _vm.popConfig.followUpPeople.id,
              row: _vm.popConfig.followUpPeople.row,
            },
            on: { closePop: _vm.closePopAndRefresh },
          }),
        ],
        1
      ),
      _c(
        "popModal",
        {
          attrs: {
            title: "选择合并人",
            "pop-config": _vm.popConfig.selectCustomer,
          },
        },
        [
          _c("selectCustomer", {
            ref: "selectCustomer",
            attrs: { type: "selectCustomer", custId: _vm.customerData.custId },
            on: { closePop: _vm.closePopAndRefresh, choose: _vm.chooseCust },
          }),
        ],
        1
      ),
      _c(
        "formModal",
        {
          attrs: {
            title: "",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 1040,
          },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticStyle: { "text-align": "center" },
          attrs: { title: "", footer: null, closeble: true },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("p", [
            _vm._v('该客户与"' + _vm._s(_vm.repeatData.custName) + '"客户重复'),
          ]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.goMerge } },
            [_vm._v("去合并")]
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "合并客户",
            footer: null,
            closeble: true,
            width: 600,
          },
          model: {
            value: _vm.merge,
            callback: function ($$v) {
              _vm.merge = $$v
            },
            expression: "merge",
          },
        },
        [
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c("a-radio", { attrs: { value: 1 } }, [
                _vm._v("主数据 "),
                _c("div", { staticClass: "item" }, [
                  _c("div", [
                    _vm._v("客户名称:" + _vm._s(_vm.customerData.custName)),
                  ]),
                  _c("div", [
                    _vm._v("电话:" + _vm._s(_vm.customerData.mobile)),
                  ]),
                  _c("div", [
                    _vm._v("企业名称:" + _vm._s(_vm.customerData.companyName)),
                  ]),
                  _c("div", [
                    _vm._v("跟进人:" + _vm._s(_vm.customerData.userName)),
                  ]),
                ]),
              ]),
              _c("a-radio", { attrs: { value: 2 } }, [
                _vm._v("主数据 "),
                _c("div", { staticClass: "item" }, [
                  _c("div", [
                    _vm._v("客户名称:" + _vm._s(_vm.repeatData.custName)),
                  ]),
                  _c("div", [_vm._v("电话:" + _vm._s(_vm.repeatData.mobile))]),
                  _c("div", [
                    _vm._v("企业名称:" + _vm._s(_vm.repeatData.companyName)),
                  ]),
                  _c("div", [
                    _vm._v("跟进人:" + _vm._s(_vm.repeatData.userName)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
            _vm._v(
              "选取主数据后，其他客户信息会被删除且不可恢复，请谨慎选择！"
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mergeCustomer },
                },
                [_vm._v("合并")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }